export default [
  {
    path: "/auth",
    meta: {
      forVisitors: true
    },
    component: () => import("../views/auth/index.vue"),
    children: [
      {
        path: "login",
        meta: {
          forVisitors: true
        },
        component: () => import("../views/auth/login.vue")
      }
    ]
  },
  {
    path: "/print",
    component: () => import("../App.vue"),
    children: [
      {
        path: "/",
        meta: {
          forAuth: true
        },
        component: () => import("@/components/global/printTable.vue")
      }
    ]
  },

  {
    path: "/",
    meta: {
      forAuth: true
    },
    component: () => import("../views/pages/index.vue"),
    children: [
      {
        path: "/",
        meta: {
          forAuth: true,
          can: "all_dashboard"
        },
        component: () => import("../views/pages/dashboard/index.vue")
      },

      {
        path: "/primary-data",
        meta: {
          forAuth: true
        },
        component: () => import("../App.vue"),
        children: [
          {
            path: "questions",
            meta: {
              forAuth: true,
              can: "all_questions"
            },
            component: () => import("../views/pages/primary-data/questions")
          },
          {
            path: ":type",
            meta: {
              forAuth: true,
              can: "all_settings"
            },
            component: () => import("../views/pages/primary-data/programs")
          }
        ]
      },
      {
        path: "/workshops",
        meta: {
          forAuth: true
        },
        component: () => import("../App.vue"),
        children: [
          {
            path: "/",
            meta: {
              forAuth: true,
              can: "all_workshops"
            },
            component: () => import("../views/pages/workshops")
          }
        ]
      },
      {
        path: "/CSOs",
        meta: {
          forAuth: true
        },
        component: () => import("../App.vue"),
        children: [
          {
            path: "/",
            meta: {
              forAuth: true,
              can: "all_CSOs"
            },
            component: () => import("../views/pages/CSOs")
          },
          {
            path: "new",
            meta: {
              forAuth: true,
              can: "add_CSOs"
            },
            component: () => import("../views/pages/CSOs/new")
          },
          {
            path: "edit/:id",
            meta: {
              forAuth: true,
              can: "add_CSOs"
            },
            component: () => import("../views/pages/CSOs/edit")
          },
          {
            path: ":id",
            meta: {
              forAuth: true,
              can: "add_CSOs"
            },
            component: () => import("../views/pages/CSOs/view")
          }
        ]
      },
      {
        path: "/reports",
        meta: {
          forAuth: true,
          can: "all_reports"
        },
        component: () => import("../App.vue"),
        children: [
          {
            path: "/",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () => import("../views/pages/reports")
          },
          {
            path: "analytical",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () => import("../views/pages/reports/analyticalReport")
          },
          {
            path: "analytical-status",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () =>
              import("../views/pages/reports/analyticalStatusReport")
          },
          {
            path: "referral-report",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () => import("../views/pages/reports/referralReport")
          },
          {
            path: "program",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () => import("../views/pages/reports/tomaticArea")
          },
          {
            path: "province",
            meta: {
              forAuth: true,
              can: "all_reports"
            },
            component: () => import("../views/pages/reports/coverageArea")
          }
        ]
      },
      {
        path: "/users",
        meta: {
          forAuth: true
        },
        component: () => import("../App.vue"),
        children: [
          {
            path: "/",
            meta: {
              forAuth: true,
              can: "all_users"
            },
            component: () => import("../views/pages/users")
          }
        ]
      },

      {
        path: "/roles",
        meta: {
          forAuth: true,
          can: "all_roles"
        },
        component: () => import("../views/pages/roles")
      },

      {
        path: "/profile",
        meta: {
          forAuth: true
        },
        component: () => import("../views/pages/users/Profile.vue")
      },
      {
        path: "/assessments-reports",
        meta: {
          forAuth: true,
          can: "view_assessments"
        },
        component: () =>
          import("../views/pages/settings/assessment_documents.vue")
      },
      {
        path: "/re-assessments-reports",
        meta: {
          forAuth: true,
          can: "view_assessments"
        },
        component: () =>
          import("../views/pages/settings/re_assessment_documents.vue")
      },
      {
        path: "/backups",
        meta: {
          forAuth: true,
          can: "all_backups"
        },
        component: () => import("../views/pages/settings/backups.vue")
      }
    ]
  },
  {
    path: "/404",
    meta: {
      forAuth: true
    },
    component: () => import("../views/auth/404.vue")
  },
  {
    path: "/401",
    meta: {
      forAuth: true
    },
    component: () => import("../views/auth/401.vue")
  },
  {
    path: "*",
    meta: {
      forVisitors: true
    },
    component: () => import("../views/auth/404.vue")
  }
];
